import { render, staticRenderFns } from "./throw.vue?vue&type=template&id=2f6d4c82&scoped=true&"
import script from "./throw.vue?vue&type=script&lang=js&"
export * from "./throw.vue?vue&type=script&lang=js&"
import style0 from "./throw.vue?vue&type=style&index=0&id=2f6d4c82&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6d4c82",
  null
  
)

export default component.exports